<template>
    <div>
        <a-drawer
                :title='title'
                :visible="visible"
                v-bind="drawerConfig"
                :body-style="{ paddingBottom: '80px' }"
                @close="onClose"
        >
            <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
                <a-form-model-item
                        ref="name"
                        label="分组"
                        prop="name"
                        :help="formErr.name"
                        :validateStatus='!formErr.name||formErr.name==""?"":"error"'
                >
                    <a-input
                            :maxLength=50
                            v-model="form.name"
                            @change="(e) => { formErr.name=''}"
                            @blur="(e) => {  form.name = e.target.value.trim();formErr.name='' }"
                    />
                </a-form-model-item>
            </a-form-model>
            <div class="drawer-btn">

                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                    确定
                </a-button>
                <a-button @click="onClose">
                取消
            </a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import {submitForm, drawerConfig, validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "customerForm",
        props: ["visible", "title", "editId"],
        data() {
            return {
                drawerConfig,
                role: [],
                form: {
                    name: "",
                },
                formErr: {
                    name: "",
                },
                rules: {
                    name: [{required: true, message: "请输入分组名称 ", trigger: "blur"}, {
                        whitespace: true,
                        message: "请输入分组名称 "
                    }, {max: 200, message: "最多填写200个字符"}, {
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.name)
                        }, trigger: "blur"
                    },],
                },
                layout: {
                    labelCol: {span: 4},
                    wrapperCol: {span: 14},
                },
            };
        },
        watch: {
            editId: function (a, b) {
                if (a != "") {
                    API.ACustomTemplate.EDIT_DATA(a).then(res => {
                        this.form.name = res.data.data.info.name
                        this.form.id = a
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted() {
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.formErr = {name: ""}
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.ACustomTemplate.SUBMIT_ADD : url = API.ACustomTemplate.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
